import React from "react";
import { VoirNestPasToujoursCroire } from "../../modules/explorer/Illusions/VoirNestPasToujoursCroire";

// Play · Illusions : premières expériences visuelles.
export default function PlayIllusions() {
  return (
    <div className="max-w-5xl mx-auto space-y-6">
        <header className="space-y-2">
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Play · Illusions</h1>
          <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
            Expériences visuelles pour montrer que la perception peut tromper. Première démo : &quot;Voir n&apos;est pas toujours croire&quot;.
          </p>
        </header>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">Illusion interactive</h2>
          <VoirNestPasToujoursCroire />
        </section>
    </div>
  );
}
